// Display-only formatting: never use this value as an identity or API lookup key.
export const formatContactPhone = (value) => {
  const raw = String(value || "").trim();
  if (!/^[+\d\s().-]+$/.test(raw)) return raw;
  const digits = raw.replace(/\D/g, "");
  const national = digits.length === 11 && digits.startsWith("1") ? digits.slice(1) : digits;
  if (national.length !== 10 || (raw.startsWith("+") && !raw.startsWith("+1"))) return raw;
  return `${national.slice(0, 3)}-${national.slice(3, 6)}-${national.slice(6)}`;
};

export const activityDate = (item) => {
  let value = item.sent_at || item.created_at;
  if (!value) return null;
  if (typeof value === "string" && /^\d{4}-\d\d-\d\d[ T]\d\d:\d\d(?::\d\d(?:\.\d+)?)?$/.test(value)) {
    value = value.replace(" ", "T") + "Z";
  }
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const groupActivityByMonth = (items) => {
  const groups = new Map();
  [...items].sort((a, b) => (activityDate(b)?.getTime() || 0) - (activityDate(a)?.getTime() || 0)).forEach((item) => {
    const date = activityDate(item);
    const key = date ? `${date.getFullYear()}-${date.getMonth()}` : "unknown";
    if (!groups.has(key)) groups.set(key, {
      key, label: date ? date.toLocaleDateString("en-US", { month: "long", year: "numeric" }) : "Date unavailable", items: [],
    });
    groups.get(key).items.push(item);
  });
  return [...groups.values()];
};

export const isFinishedTask = (item) => ["closed", "completed", "complete", "done", "cancelled", "canceled"].includes(String(item.status || "").toLowerCase());

// Only recognize our exact appended footer. Keep the source body untouched.
export const splitImportedBody = (value) => {
  const text = String(value || "");
  const match = /\n\n(\[Salesforce [A-Za-z_]+ [A-Za-z0-9]{15}(?:[A-Za-z0-9]{3})?; original author: [^\]\n]+\])\s*$/.exec(text);
  return match ? { body: text.slice(0, match.index), details: match[1] } : { body: text, details: "" };
};
